var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHappiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "62C92CCA-4C75-475D-A7C1-2E7FBF1DFF4E-523-00000CD003F94369") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfolio-builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5b-client-profile-moneymind",
    transform: "translate(-405.000000, -315.000000)",
    fill: "#F49500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-area",
    transform: "translate(60.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "client-profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clarence",
    transform: "translate(72.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "percentage",
    transform: "translate(0.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "happiness",
    transform: "translate(240.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(14.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/hc/commitment",
    transform: "translate(19.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0000175,1.70562737e-08 C24.836542,1.70562737e-08 32.0000009,7.16345895 32.0000009,16.0000859 C32.0000009,24.8365761 24.836542,32.0000351 16.0000175,32.0000351 C7.16349313,32.0000351 1.70562737e-08,24.8365761 1.70562737e-08,16.0000859 C1.70562737e-08,7.16345895 7.16349313,1.70562737e-08 16.0000175,1.70562737e-08 Z M16.0000016,6.5454832 C10.7784341,6.5454832 6.5454832,10.7783498 6.5454832,16.0000859 C6.5454832,21.2215479 10.7784341,25.454541 16.0000016,25.454541 C21.2215901,25.454541 25.454541,21.2215479 25.454541,16.0000859 C25.454541,10.7783498 21.2215901,6.5454832 16.0000016,6.5454832 Z M10.5184928,12.9581256 C10.5184928,12.9581256 12.4288771,16.6249902 15.688845,17.3587694 C18.9496857,18.0919071 22.5485813,16.6249902 22.5485813,16.6249902 C22.5485813,16.6249902 21.3864161,25.8026593 13.2746419,22.6611161 C6.86161527,20.1792946 10.5184928,12.9581256 10.5184928,12.9581256 Z",
    id: "ic_happiness"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHappiness);
export default __webpack_public_path__ + "static/media/ic_happiness.d78d0b9a79cbecd2e488eeacf916f922.svg";
export { ForwardRef as ReactComponent };